import { Controller } from "stimulus";
import Rails from "@rails/ujs";

const POLL_INTERVAL = 5000; // 5 seconds
const MAX_POLL_ATTEMPTS = 24; // 2 minutes

export default class extends Controller {
  static targets = ['button', 'progress'];

  static values = {
    exportUrl: String,
    statusUrl: String,
    downloadUrl: String,
    errorMessage: String
  }

  disconnect() {
    clearTimeout(this.pollTimeout);
  }

  start() {
    this.pollAttempts = 0;
    this.toggleProgress(true);

    Rails.ajax({
      url: this.exportUrlValue,
      type: 'POST',
      success: () => this.checkStatus(),
      error: () => this.fail(),
    });
  }

  checkStatus() {
    Rails.ajax({
      url: this.statusUrlValue,
      type: 'GET',
      dataType: 'json',
      success: (response) => this.handleStatus(response.status),
      error: () => this.fail(),
    });
  }

  handleStatus(status) {
    if (status === 'pending' && this.pollAttempts < MAX_POLL_ATTEMPTS) {
      this.pollAttempts += 1;
      this.pollTimeout = setTimeout(() => this.checkStatus(), POLL_INTERVAL);
    } else if (status === 'success') {
      this.toggleProgress(false);
      window.location.href = this.downloadUrlValue;
    } else {
      this.fail();
    }
  }

  fail() {
    this.toggleProgress(false);

    document.dispatchEvent(new CustomEvent('promote:display-error-message', {
      detail: { message: this.errorMessageValue }
    }));
  }

  toggleProgress(inProgress) {
    this.buttonTarget.disabled = inProgress;
    this.progressTarget.classList.toggle('hidden', !inProgress);
  }
}
